import Vue from 'vue'
import Storage from 'store'

Vue.prototype.$storage = Storage
Vue.prototype.$storage.addPlugin(require('store/plugins/expire'))
